if (!customElements.get('card-variant-pills')) {
  customElements.define(
    'card-variant-pills',
    class CardVariantPills extends HTMLElement {
      connectedCallback() {
        this.cardRoot = this.closest('[data-card-root]') || this.closest('.card-wrapper') || this;
        const priceWrap = this.cardRoot.querySelector('[data-card-price]');
        this.priceEl = (priceWrap && priceWrap.querySelector('.price')) || priceWrap;
        this.imageEl = this.cardRoot.querySelector('[data-card-media-image]');
        this.variantInput = this.cardRoot.querySelector('[data-card-add-variant-id]');
        this.submitBtn = this.cardRoot.querySelector('[data-card-add-submit]');
        this.labelEl = this.submitBtn ? this.submitBtn.querySelector('[data-card-add-label]') : null;

        this.addEventListener('click', this.onPillClick.bind(this));
      }

      onPillClick(event) {
        const pill = event.target.closest('.card-variant-pill');
        if (!pill || !this.contains(pill)) return;
        this.selectVariant(pill);
      }

      selectVariant(pill) {
        this.querySelectorAll('.card-variant-pill').forEach((el) => {
          const selected = el === pill;
          el.classList.toggle('is-selected', selected);
          el.setAttribute('aria-checked', selected ? 'true' : 'false');
        });

        const available = pill.dataset.available === 'true';

        if (this.variantInput) {
          // Covers both patterns used across cards: a hidden form <input>
          // (card-product.liquid, best-sellers-tabs.liquid) and a button that
          // carries the variant id directly in a data attribute read at click
          // time by its own add-to-cart handler (fcs-slide.liquid).
          this.variantInput.value = pill.dataset.variantId;
          this.variantInput.dataset.variantId = pill.dataset.variantId;
        }

        this.updatePrice(pill);
        this.updateImage(pill);
        this.updateSubmit(available);
      }

      updatePrice(pill) {
        if (!this.priceEl) return;
        const price = pill.dataset.price;
        const comparePrice = pill.dataset.comparePrice;
        const onSale = !!comparePrice;

        this.priceEl.classList.toggle('price--on-sale', onSale);
        this.priceEl.classList.toggle('price--sold-out', pill.dataset.available !== 'true');

        // Dawn's price component (shared card-product.liquid snippet)
        const regularItem = this.priceEl.querySelector('.price__regular .price-item--regular');
        if (regularItem && price) regularItem.textContent = price;

        const saleCompareItem = this.priceEl.querySelector('.price__sale s');
        const saleItem = this.priceEl.querySelector('.price__sale .price-item--sale');
        if (onSale) {
          if (saleCompareItem) saleCompareItem.textContent = comparePrice;
          if (saleItem && price) saleItem.textContent = price;
        }

        const discountBadge = this.priceEl.querySelector('.price__discount-badge');
        if (discountBadge && pill.dataset.discountBadge) {
          discountBadge.textContent = pill.dataset.discountBadge;
        }

        // Generic contract (bespoke cards: best-sellers-tabs.liquid, fcs-slide.liquid)
        const genericRegular = this.priceEl.querySelector('[data-card-price-regular]');
        const genericCompare = this.priceEl.querySelector('[data-card-price-compare]');
        if (genericRegular && price) genericRegular.textContent = price;
        if (genericCompare) {
          genericCompare.hidden = !onSale;
          if (onSale && comparePrice) genericCompare.textContent = comparePrice;
        }
      }

      updateImage(pill) {
        if (!this.imageEl) return;
        const src = pill.dataset.image;
        if (!src) return;
        this.imageEl.src = src;
        this.imageEl.removeAttribute('srcset');
        if (pill.dataset.imageWidth) this.imageEl.setAttribute('width', pill.dataset.imageWidth);
        if (pill.dataset.imageHeight) this.imageEl.setAttribute('height', pill.dataset.imageHeight);
        if (pill.dataset.imageAlt) this.imageEl.alt = pill.dataset.imageAlt;
      }

      updateSubmit(available) {
        if (!this.submitBtn) return;
        this.submitBtn.disabled = !available;
        this.submitBtn.classList.toggle('is-soldout', !available);
        if (this.labelEl) {
          this.labelEl.textContent = available
            ? this.dataset.addLabel || '+ ADD'
            : this.dataset.soldOutLabel || 'Sold out';
        }
      }
    }
  );
}
